import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import { Private_Routes } from '../../../constants';
import { AuditLogDetailsDto } from '../models/auditLog.model';
import {
  formatAuditDate,
  getOperationKind,
  parseAffectedColumnsJson,
} from '../utils/auditLogHelpers';

const opBadge: Record<ReturnType<typeof getOperationKind>, { label: string; variant: string }> = {
  create: { label: 'Alta', variant: 'success' },
  update: { label: 'Cambio', variant: 'primary' },
  delete: { label: 'Baja', variant: 'danger' },
  unknown: { label: '?', variant: 'secondary' },
};

interface Props {
  data: AuditLogDetailsDto[];
  listSearchSuffix: string;
}

export function AuditLogsTable({ data, listSearchSuffix }: Props) {
  if (!data?.length) {
    return (
      <div className="text-center text-muted py-5">
        <i className="ri-inbox-line fs-1 d-block mb-2" />
        No hay registros de auditoría con los filtros actuales.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th>Fecha</th>
            <th>Operación</th>
            <th>Usuario</th>
            <th>Empleado</th>
            <th>Entidades</th>
            <th className="text-end">Detalle</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            const kind = getOperationKind(row.operation);
            const b = opBadge[kind];
            const cols = parseAffectedColumnsJson(row.affectedColumns);
            const summary =
              cols.length <= 5
                ? cols.join(', ')
                : `${cols.slice(0, 5).join(', ')} (+${cols.length - 5})`;

            return (
              <tr key={row.id}>
                <td className="text-nowrap">{formatAuditDate(row.date)}</td>
                <td>
                  <Badge bg={b.variant}>{b.label}</Badge>
                  <span className="text-muted small ms-1">{row.operationDescription}</span>
                </td>
                <td>{row.userFullName || '—'}</td>
                <td>{row.employeeFullName || '—'}</td>
                <td>{row.parsedEntityName || '—'}</td>
                <td className="text-end">
                  <Link
                    className="btn btn-sm btn-soft-primary"
                    to={Private_Routes.AUDIT_LOGS.detail.replace(':auditLogId', String(row.id))}
                    state={{ listSearchSuffix }}
                  >
                    Ver
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
